module.exports = __webpack_public_path__ + "img/IFEA-Treuhand-GmbH-LOGO-INLINE.7db79cae.png";